import ActivityFilters from '../ActivityFilters/ActivityFilters'
import { sections } from './OtherActivitiesList'

import PropTypes from 'prop-types'
import styles from '../ActivitiesList.module.scss'
import cx from 'classnames'
import { CoursesSliderLazyLoad } from '../CoursesSliderLazyLoad'

const CoursesList = ({
  diveCenterId,
  type,
  courseFilters,
  isWidget,
  wechatQr,
}) => {
  return (
    <div className={cx('wrapper trip-wrapper', styles.coursesContainer)}>
      <h3 className='do-section-title'>{sections[type].title}</h3>
      <ActivityFilters activityType={type} courseFilters={courseFilters} />
      <CoursesSliderLazyLoad
        diveCenterId={diveCenterId}
        isWidget={isWidget}
        wechatQr={wechatQr}
      />
    </div>
  )
}

export default CoursesList

CoursesList.propTypes = {
  diveCenterId: PropTypes.string,
  type: PropTypes.string,
  courseFilters: PropTypes.object,
  isWidget: PropTypes.bool,
  wechatQr: PropTypes.string,
}
